var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
import { lockPageScroll, unlockPageScroll } from './scrollLock';
/**
 * Called when scroll is being locked.
 * @name onLockScroll
 * @function
 */
/**
 * Called when scroll is being unlocked.
 * @name onUnlockScroll
 * @function
 */
/**
 * Function argument.
 * @name func
 * @function
 */
/**
 * Lock an overlay component.
 * @param {boolean} isOpen Indicates whether the overlay is open.
 * @param {boolean} hasOverlayMounted Indicates whether the overlay has mounted.
 * @param {boolean|func|string} scrollLock locks the scroll position of an element (useful for mobile swipe events), true: locks the body element, false: does not lock any elements, String: id of an element to be locked
 * @param {onLockScroll} onLockScroll Gets called when the scroll is being locked
 * @param {onUnlockScroll} onUnlockScroll Gets called when the scroll is being unlocked
 * @returns
 */
var useScrollLock = function (_a) {
    var isOpen = _a.isOpen, hasOverlayMounted = _a.hasOverlayMounted, scrollLock = _a.scrollLock, _b = _a.onLockScroll, onLockScroll = _b === void 0 ? function () { } : _b, _c = _a.onUnlockScroll, onUnlockScroll = _c === void 0 ? function () { } : _c;
    var _d = __read(useState(), 2), elementWithLockedScroll = _d[0], setElementWithLockedScroll = _d[1];
    // Lock panel (scrollLock)
    useEffect(function () {
        if (!scrollLock || !isOpen)
            return;
        if (!elementWithLockedScroll)
            lockPageScroll(scrollLock, setElementWithLockedScroll);
        onLockScroll();
        // If user abruptly leaves Panel, unlock the page scroll if possible
        return function () {
            if (scrollLock && elementWithLockedScroll && setElementWithLockedScroll)
                unlockPageScroll(elementWithLockedScroll, setElementWithLockedScroll);
        };
    }, [
        elementWithLockedScroll,
        onLockScroll,
        hasOverlayMounted,
        isOpen,
        scrollLock
    ]);
    // Unlock panel (scrollLock)
    useEffect(function () {
        if (!scrollLock || isOpen || !hasOverlayMounted)
            return;
        if (elementWithLockedScroll) {
            unlockPageScroll(elementWithLockedScroll, setElementWithLockedScroll);
            onUnlockScroll();
        }
    }, [
        elementWithLockedScroll,
        scrollLock,
        onUnlockScroll,
        hasOverlayMounted,
        isOpen
    ]);
};
export { useScrollLock };
